// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"c2a6ed02","709":"03a6842d"}[chunkId] + ".chunk.js";
};